import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { deleteDistrict, getAllDistricts, createDistrict, editDistrict } from '../../api/axiosDistricts';
import { getAllRegions } from '../../api/axiosRegions';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';






const Districts = () => {
  const { regions, setRegions,districts, setDistricts, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedEditedRegion, setSelectedEditedRegion] = useState("");
  
  const [district, setDistrict] = useState("");
  const [editedDistrict, setEditedDistrict] = useState("");
  


 

  const NewTitle = "All Districts";
  useEffect(() => {
    
    getAllDistricts(setDistricts, setFetcherror);
    getAllRegions(setRegions, setFetcherror);
    
  }, []);

  // Create New Array of Districts with Regions.
  const newdistrictsArray = districts.map((item) => {
    const result = regions.find((itemb) => itemb.id === item.region_id);
    return { ...item, region: result ? result.name : null };
  });
  

  const filteredDistricts = newdistrictsArray.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()) || item.region.toLowerCase().includes(globalFilter.toLowerCase()))
  const filteredReversedDistricts = filteredDistricts.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setDistricts, setFetcherror, handleAllToasts) => {
    return () => {
      deleteDistrict(pkid, setDistricts, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this District?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedDistrict(foundItem?.name);
    setSelectedEditedRegion(regions.find((region)=>region.id === foundItem.region_id));
  }



  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
        <SearchToolBar
            setAddItemDialogVisible={setAddItemDialogVisible}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            searchPlaceholder="Districts"
            createLabel="District"
         />

        <DataTable
          value={filteredDistricts}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="Fetching Districts"
        >
                    <Column header="S/N" body={(rowData) => newdistrictsArray.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Region" body={(rowData) => rowData.region } sortable></Column>
                    <Column header="District"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                            <TableActions
                            id={rowData.id}
                            data={districts}
                            getItemtoEdit={getItemtoEdit}
                            setSelectedId={setSelectedId}
                            setEditDialogVisible={setEditDialogVisible}
                            setDeleteDialogVisible={ setDeleteDialogVisible}
                          />
                         
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New District" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createDistrict(district,selectedRegion?.id, setDistrict, setFetcherror, handleAllToasts, setDistricts);
                if (district ) { setAddItemDialogVisible(false); }
              }}>
                   <label htmlFor="districtregion" className="block text-900 font-medium mb-2">Region </label>
                  <Dropdown
                   value={selectedRegion} onChange={(e) => setSelectedRegion(e.value)}
                   options={regions} optionLabel="name"
                  placeholder="-- Select Region --" showClear className="w-full mb-4"
                  />
                

                  <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">District </label>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter District Name"
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setDistrict("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit District" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editDistrict( selectedId, editedDistrict, setEditedDistrict, selectedEditedRegion, setSelectedEditedRegion, setFetcherror, handleAllToasts, setDistricts);
                if (editedDistrict) { setEditDialogVisible(false); }
                }}>
                  
                  <label htmlFor="districtregion" className="block text-900 font-medium mb-2">Region </label>
                  <Dropdown
                   value={selectedEditedRegion} onChange={(e) => setSelectedEditedRegion(e.value)}
                   options={regions} optionLabel="name"
                  placeholder="-- Select Region --" showClear className="w-full mb-4"
                  />

                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter District Name"
                    value={editedDistrict}
                    onChange={(e) => setEditedDistrict(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setDistrict("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setDistricts, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Districts


